const StagesEnum = Object.assign({
  DRAFT: 'draft',
  PUBLISHED: 'published',
  CLOSED: 'closed',
  DECLINED: 'declined',
  IN_INSOLVENCY_PROCEEDING: 'in_insolvency_proceeding',
  DEFAULTED: 'defaulted',
});

Object.freeze(StagesEnum);

export default StagesEnum;



// WEBPACK FOOTER //
// ./src/enum/financialProducts/Stages.js